export default "__VITE_ASSET__oUcKf$lg__"